type RoundData = {
	results: Record<string, { score?: number }>;
};

type AggregateResult = Record<string, { score: number }>;

// Aggregate results from multiple rounds
function aggregate(rounds: Record<string, RoundData>): AggregateResult {
	const finalResults: AggregateResult = {};
	Object.keys(rounds).forEach((roundIdx) => {
		const results = rounds[roundIdx].results;
		Object.keys(results).forEach((playerId) => {
			if (!finalResults[playerId]) {
				finalResults[playerId] = { score: results[playerId].score ?? 0 };
			} else {
				finalResults[playerId].score += results[playerId].score ?? 0;
			}
		});
	});

	return finalResults;
}

export { aggregate };

export default aggregate;
